import { parseData } from '@devhacker/shared/utils/parseData';
import type { ReactionResponse } from '~/types/api/reactions';
import type { AvailableReaction } from '~/types/components/Reactions';
import { fetchReactionSchema } from '~/schemas/reactionsSchema';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import { defineStore } from 'pinia';

export const useReactionsStore = wrapPiniaStore(
  defineStore('reactions', {
    state: () => ({
      reactions: {} as Record<string, ReactionResponse>,
    }),

    getters: {
      getReactions: (state) => state.reactions,
    },

    actions: {
      async fetchReactions(slug: string) {
        const { data } = await useNuxtApp().$api.reactions.fetchReactions(slug);

        const parsedData = parseData(data, fetchReactionSchema);

        parsedData.success && this.setReactions(parsedData.data, false);
      },

      // use instead of dispatch UpdateReaction
      async updateReaction(slug: string, user_state: AvailableReaction) {
        const { data } = await useNuxtApp().$api.reactions.updateReaction(slug, user_state);

        const parsedData = parseData(data, fetchReactionSchema);

        parsedData.success && this.setReactions(parsedData.data, true);
      },

      // Use instead of commit updateReactions
      setReactions(reactions: ReactionResponse, isUserChangeReaction: boolean) {
        if (!reactions) return;

        const { post_id, user_state, updated_at } = reactions;
        this.reactions[post_id] = reactions;

        // * для реакции без авторизации
        if (import.meta.client && isUserChangeReaction) {
          const reactionsLocalState = JSON.parse(localStorage.getItem('reactions-state') || '{}');

          if (!user_state) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete reactionsLocalState[post_id];
          } else {
            reactionsLocalState[post_id] = {
              user_state,
              updated_at,
            };
          }

          window.localStorage.setItem('reactions-state', JSON.stringify(reactionsLocalState));
          window.localStorage.getItem('reactions-state');
        }
      },
    },
  }),
);
